(() => {
  if (window.__faCollectionFooter) return;
  window.__faCollectionFooter = true;

  const initRoot = (root) => {
    if (!root || root.dataset.faCollectionFooterReady === 'true') return;
    root.dataset.faCollectionFooterReady = 'true';

    const content = root.querySelector('[data-fa-seo-content]');
    const faqSlot = root.querySelector('[data-fa-faq-slot]');
    const faq = content?.querySelector('.fa-faq');
    if (faq && faqSlot) {
      faqSlot.appendChild(faq);
      faqSlot.hidden = false;
    }

    const triggers = root.querySelectorAll('.fa-accordion__trigger');
    triggers.forEach((trigger) => {
      if (trigger.dataset.faAccordionBound === 'true') return;
      trigger.dataset.faAccordionBound = 'true';
      trigger.addEventListener('click', () => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
        if (!panel) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        triggers.forEach((other) => {
          if (other === trigger) return;
          const otherId = other.getAttribute('aria-controls');
          const otherPanel = otherId ? root.querySelector(`#${CSS.escape(otherId)}`) : null;
          other.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
      });
    });
  };

  const scan = (scope = document) => scope.querySelectorAll?.('[data-fa-collection-footer]').forEach(initRoot);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
